export function moneyFormat(
    number: number,
    decimals: number = 2,
    sectionsSeperator: string = ".",
    decimalSeperator: string = ","
) {
    if (typeof number !== "number" || isNaN(number)) {
        return "";
    }

    const x = 3;
    var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (decimals > 0 ? "\\D" : "$") + ")",
        num = number.toFixed(Math.max(0, ~~decimals));

    return (decimalSeperator ? num.replace(".", decimalSeperator) : num).replace(
        new RegExp(re, "g"),
        "$&" + (sectionsSeperator || ",")
    );
}

export function getDiscountedPrice(price: number, discount: number) {
    return price - price * (discount / 100);
}

export function randomNumberBetween(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
